export interface Classification {
  type: string;
  subtype: string;
  cause: string;
  clusterAssignment: string;
  followUpTreatment: boolean;
  followUpTreatmentClaim: string;
  followUpTreatmentCluster: string;
  preexistingCondition: boolean;
  emergencyAbroad: boolean;
  chronicDisease: boolean;
  obligationsFulfilled: boolean;
  furtherClarificationComment: string;
  covered: boolean;
  reasonNotCovered: string;
  courseOfEvents: string;
  genericComment: string;
  preexistingConditionsUsedUpDeductible?: number;
  accidentDate: string | null;
  ignoreWaitingPeriod: boolean;
  reasonNotCoveredText?: string;
  reasonForVisit?: string;
  checks?: {
    medicalFoodPrescription?: boolean,
    complementaryMedicinePrescription?: boolean,
    complementaryMedicineTherapist?: boolean,
    behavioralTreatmentTherapist?: boolean,
  }
}

export enum ClassificationReasonNotCovered {
  WithinDeductible = 'within-deductible',
  WithinWaitingPeriod = 'within-waiting-period',
  NoCoverageAccordingToGTC = 'no-coverage-according-to-gtc',
  DamageBeforeContractStart = 'damage-before-contract-start',
  DamageAfterContractEnd = 'damage-after-contract-end',
  CoverageInterrupt = 'coverage-interrupt',
  DivisionNotInsured = 'division-not-insured',
  AdditionalCoverageNotInsured = 'additional-coverage-not-insured',
  Others = 'others',
}
